export const ADMIN = "Admin";
export const TEACHER = "Teacher";
export const DEPARTMENT = "Department";
export const EDUCATIONAL_DEPARTMENT = "EducationalDepartment";
export const HEAD_OF_DEPARTMENT = "HeadOfDepartment";
